import { restore } from 'effector';

import { getFeaturesFx } from 'shared/api';

export const $features = restore(getFeaturesFx.doneData, null);

export const $isNewOccasionsEnabled = $features.map(
  (features) => features?.some((f) => f.feature.key === 'OCCASIONS' && f.isEnabled),
  { skipVoid: false }
);

export const $isHoroscopeEnabled = $features.map(
  (features) => features?.some((f) => f.feature.key === 'HOROSCOPE' && f.isEnabled),
  { skipVoid: false }
);
